import moment from "moment-timezone";
import {
  translationConstants,
  sportConstants,
  timezoneConstants,
} from "../../../../constants";
import { dateToUTCWithTimezone } from "../../../../system";

export const getSportNameById = (id) => {
  const entries = Object.entries(sportConstants);
  const inverted = entries.reduce(
    (obj, [key, value]) => ({ ...obj, [value]: key }),
    {}
  );
  return inverted[id];
};

// export const localTimeConverter = (date) => {
//   return moment(date * 1000).local();
// };

// export const RemainingDaysHandler = (t, data) => {
//   if (data?.isPublicRegistrationAllowed) {
//     if (
//       moment().isSameOrBefore(localTimeConverter(data?.registrationStartDate))
//     ) {
//       return (
//         <>
//           {`*${t(translationConstants.REGISTRATION_STRING_OPEN)} ${
//             data?.registrationStartsInDays
//           } ${t(translationConstants.DAYS)}.`}
//         </>
//       );
//     } else if (
//       moment().isAfter(localTimeConverter(data?.registrationStartDate)) &&
//       moment().isSameOrBefore(localTimeConverter(data?.registrationEndDate))
//     ) {
//       return (
//         <>
//           {`*${t(translationConstants.REGISTRATION_STRING_CLOSED)} ${
//             data?.registrationEndsInDays
//           } ${t(translationConstants.DAYS)}.`}
//         </>
//       );
//     }
//   }
// };

export const buttonTextHandler = (t, data) => {
  if (!data?.isPublicRegistrationAllowed) {
    return t(translationConstants.INVITE_ONLY);
  } else if (
    moment(
      data?.registrationEndDateString,
      timezoneConstants.dateTimeFormatForServer
    ).isSameOrAfter(dateToUTCWithTimezone(), "days")
  ) {
    return t(translationConstants.REGISTER_NOW);
  } else {
    return t(translationConstants.REGISTRATION_CLOSED);
  }
};
